module.exports = __webpack_public_path__ + "img/orbit-card-total-token-rewards-mobile.0067ad4f.png";